export default "__VITE_ASSET__gwGnhBVx__"